import axios from './axios';

export default productId =>
  axios.get(`/catalog/productconfiguration/ProductDimension?productId=${productId}`);
